import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import {RunState} from '@wandb/weave/components/RunState';
import * as _ from 'lodash';
import React from 'react';
import {Mutation} from 'react-apollo';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, Popup} from 'semantic-ui-react';

import DangerModal from '../components/DangerModal';
import {
  STOP_RUN,
  StopRunMutationData,
  StopRunMutationVariables,
} from '../graphql/runs';
import {versionGte} from '../util/version';

interface RunStateIndicatorProps {
  run: {
    id: string;
    config: any;
    state: string;
    stopped: boolean;
  };
  readOnly?: boolean;
}

const RunStateIndicator: React.FC<RunStateIndicatorProps> = props => {
  const [stopPressed, setStopPressed] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);

  const stopRunAvailable = () => {
    const parsedConfig = JSON.parse(props.run.config);
    const cliVersion = _.get(parsedConfig, '_wandb.value.cli_version');
    if (cliVersion == null) {
      return false;
    }

    const isJupyterRun =
      _.get(parsedConfig, '_wandb.value.is_jupyter_run') ?? false;

    return versionGte(cliVersion, '0.8.6') && !isJupyterRun;
  };

  const canBeStopped = () => {
    // NOTE: it's possible that props.run.stopped is true but that we failed to
    // actually stop the run -- in that case let the user try to stop it again.
    return !stopPressed && props.run.state === 'running';
  };

  const isStopping = () => {
    return (stopPressed || props.run.stopped) && props.run.state === 'running';
  };

  return (
    <div className="run-state-indicator">
      <RunState value={isStopping() ? 'stopping' : props.run.state} />
      {stopRunAvailable() && canBeStopped() && (
        <Mutation<StopRunMutationData, StopRunMutationVariables>
          mutation={STOP_RUN}>
          {stopRun => (
            <DangerModal
              open={modalOpen}
              onClose={() => setModalOpen(false)}
              trigger={
                <Popup
                  position="right center"
                  size="mini"
                  inverted
                  trigger={
                    <Button
                      size="tiny"
                      className="stop-button"
                      onClick={() => setModalOpen(true)}>
                      <LegacyWBIcon name="stop" />
                    </Button>
                  }>
                  {props.run.stopped
                    ? `Retry stop run (this can take several minutes)`
                    : `Stop run`}
                </Popup>
              }
              message="Are you sure you want to STOP this run? This action cannot be undone!"
              yesText="Stop this run"
              yes={() => {
                stopRun({variables: {id: props.run.id}});
                setStopPressed(true);
              }}
            />
          )}
        </Mutation>
      )}
    </div>
  );
};

export default RunStateIndicator;
